<div class="registration-page">
  <div class="registration-container">
    <h1>Информация о компании</h1>
    <p class="subtitle">Заполните информацию о компании</p>


    <!-- Степпер только для ООО -->
    @if (isLLC()) {
    <div class="stepper-container">
      <div class="step" [class.active]="currentStep() === 0" [class.completed]="currentStep() > 0">
        <div class="step-number">1</div>
        <span>Информация о компании</span>
      </div>
      <div class="step-line" [class.completed]="currentStep() > 0"></div>
      <div class="step" [class.active]="currentStep() === 1">
        <div class="step-number">2</div>
        <span>Контактная информация</span>
      </div>
    </div>
    }

    <div class="form-container" [class.loading]="loadingForm()">
      @if (loadingForm()) {
      <div class="loading-overlay">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Загрузка данных...</p>
      </div>
      }

      <!-- ШАГ 1 -->
      @if (currentStep() === 0) {
      <form [formGroup]="step1Form">
        <!-- Карточка 1: Информация о компании -->
        <mat-card class="form-card">
          <mat-card-header>
            <mat-card-title>1. Информация о компании</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- ИНН -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>ИНН компании</mat-label>
              <input matInput formControlName="inn" (input)="onInnChange($event)" maxlength="14"
                placeholder="Введите 14 цифр">
              @if (step1Form.get('inn')?.hasError('required') && step1Form.get('inn')?.touched) {
              <mat-error>ИНН обязателен</mat-error>
              }
              @if (step1Form.get('inn')?.hasError('pattern') && step1Form.get('inn')?.touched) {
              <mat-error>ИНН должен состоять из 14 цифр</mat-error>
              }
            </mat-form-field>

            <!-- Название компании -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Название компании</mat-label>
              <input matInput formControlName="companyName">
              @if (step1Form.get('companyName')?.hasError('required') && step1Form.get('companyName')?.touched) {
              <mat-error>Название компании обязательно</mat-error>
              }
            </mat-form-field>

            <!-- ОКПО - только для ООО -->
            @if (isLLC()) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>ОКПО</mat-label>
              <input matInput formControlName="okpo">
            </mat-form-field>

            <!-- Юридический статус -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Юридический статус</mat-label>
              <mat-select formControlName="legalStatusId">
                @for (status of legalStatuses(); track status.id) {
                <mat-option [value]="status.id">{{ status.nameRu }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            }

            <!-- Регистрационный номер -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Регистрационный номер</mat-label>
              <input matInput formControlName="registrationNumber">
              @if (step1Form.get('registrationNumber')?.hasError('required') &&
              step1Form.get('registrationNumber')?.touched) {
              <mat-error>Регистрационный номер обязателен</mat-error>
              }
            </mat-form-field>

            <!-- Дата регистрации -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Дата регистрации</mat-label>
              <input matInput [matDatepicker]="regDatePicker" formControlName="registrationDate">
              <mat-datepicker-toggle matIconSuffix [for]="regDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #regDatePicker></mat-datepicker>
              @if (step1Form.get('registrationDate')?.hasError('required') &&
              step1Form.get('registrationDate')?.touched) {
              <mat-error>Дата регистрации обязательна</mat-error>
              }
            </mat-form-field>
          </mat-card-content>
        </mat-card>

      </form>
      }

      <!-- ШАГ 2 - только для ООО -->
      @if (currentStep() === 1 && isLLC()) {
      <form [formGroup]="step2Form">
        <mat-card class="form-card">
          <mat-card-header>
            <mat-card-title>3. Контактная информация</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <!-- Действует как -->
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Действует как</mat-label>
              <mat-select formControlName="actingAs">
                @for (option of actingAsOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
              @if (step2Form.get('actingAs')?.hasError('required') && step2Form.get('actingAs')?.touched) {
              <mat-error>Выберите в каком качестве действуете</mat-error>
              }
            </mat-form-field>

            <!-- Поля доверенности - только для агента -->
            @if (showAgentFields()) {
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Номер доверенности</mat-label>
              <input matInput formControlName="contractNumber">
              @if (step2Form.get('contractNumber')?.hasError('required') && step2Form.get('contractNumber')?.touched) {
              <mat-error>Номер доверенности обязателен</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Дата доверенности</mat-label>
              <input matInput [matDatepicker]="contractDatePicker" formControlName="contractDate">
              <mat-datepicker-toggle matIconSuffix [for]="contractDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #contractDatePicker></mat-datepicker>
              @if (step2Form.get('contractDate')?.hasError('required') && step2Form.get('contractDate')?.touched) {
              <mat-error>Дата доверенности обязательна</mat-error>
              }
            </mat-form-field>
            }
          </mat-card-content>
        </mat-card>
      </form>
      }

      <!-- Сообщение об ошибке -->
      @if (errorMessage()) {
      <div class="error-message">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage() }}</span>
      </div>
      }

      <!-- Кнопки навигации -->
      <div class="form-actions">
        @if (currentStep() === 0) {
        <button mat-stroked-button class="back-btn" (click)="goBack()">
          Отмена
        </button>
        @if (isLLC()) {
        <button mat-raised-button color="primary" (click)="goNext()">
          Далее
        </button>
        } @else if (isIE()) {
        <button mat-raised-button color="primary" (click)="handleRegistration()" [disabled]="loading()">
          @if (loading()) {
          <mat-spinner diameter="20"></mat-spinner>
          } @else {
          Зарегистрироваться
          }
        </button>
        }
        }

        @if (currentStep() === 1) {
        <button mat-stroked-button class="back-btn" (click)="goPrev()">
          Назад
        </button>
        <button mat-raised-button color="primary" (click)="handleRegistration()" [disabled]="loading()">
          @if (loading()) {
          <mat-spinner diameter="20"></mat-spinner>
          } @else {
          Зарегистрироваться
          }
        </button>
        }
      </div>
    </div>
  </div>
</div>